import { Icon, Input, theme } from 'components';
import { useDebounce } from 'hooks';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useShowingsCalendarContext } from '../ShowingsCalendarContext';
import { AgentCalendarMenu } from '../types';

const SearchBar: React.FC = () => {
  const context = useShowingsCalendarContext();
  const { searchText, setSearchText, selectedMenuOption } = context;

  const [localText, setLocalText] = useState(searchText);
  const debouncedText = useDebounce(localText, 500);

  useEffect(() => {
    setSearchText(debouncedText);
  }, [debouncedText]);

  useEffect(() => {
    setLocalText(searchText);
  }, [selectedMenuOption]);

  const searchChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalText(e.target.value);
  };

  return (
    <>
      <StyledInput
        allowClear
        placeholder="Search showings"
        prefix={<Icon type="search" color="gray9" offset={[0, -1]} />}
        onChange={searchChangeHandler}
        // disable search for managed access tab
        disabled={selectedMenuOption === AgentCalendarMenu.ManagedAccess}
        value={localText}
        type="text"
        data-cy="showings-calendar-search"
      />
    </>
  );
};

const StyledInput = styled(Input)`
  border-radius: ${theme.getBorderRadius('small')};
  width: 100%;
`;

export default SearchBar;
